import { render, staticRenderFns } from "./ApplicationsDetail.vue?vue&type=template&id=d724f856&scoped=true&"
import script from "./ApplicationsDetail.vue?vue&type=script&lang=js&"
export * from "./ApplicationsDetail.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationsDetail.vue?vue&type=style&index=0&id=d724f856&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d724f856",
  null
  
)

export default component.exports